module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "sky-crop"
  }, [(_vm.type === 'img') ? _c('img', {
    staticClass: "element",
    style: (_vm.styleObject),
    attrs: {
      "alt": _vm.altText,
      "src": _vm.srcString
    }
  }) : _c('div', {
    staticClass: "element",
    style: (_vm.styleObject)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue-loader/lib/template-compiler.js?{"id":"data-v-0d71366e"}!./scripts/sky-crop/sky-crop.html
// module id = 255
// module chunks = 1